import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
	selector: '[appMatChipPaste]'
})
export class MatChipPasteDirective {

	constructor(private _control: NgControl,
				private _el: ElementRef) {
	}

	@HostListener('paste', ['$event']) onEvent(event) {
		event.preventDefault();
		const ev = new KeyboardEvent('keydown', {
			altKey: false,
			bubbles: true,
			cancelable: true,
			code: 'Enter',
			composed: true,
			ctrlKey: false,
			detail: 0,
			isComposing: false,
			key: 'Enter',
			keyCode: 13,
			location: 0,
			metaKey: false,
			repeat: false,
			shiftKey: false
		});
		event.clipboardData.getData('text').split(/[;,\n]/).forEach((chip) => {
			if (chip && chip?.trim() != '')
			{
				this._control.control.setValue(chip?.trim());
				this._el.nativeElement.dispatchEvent(ev);
			}
		});
	}

}
